import React from "react";

export const LanguageToggle = ({ lang, setLang }) => {
  return (
    <button
      onClick={() => setLang(lang === "en" ? "ru" : "en")}
      data-testid="language-toggle"
      className="group relative flex items-center gap-1 text-[11px] uppercase tracking-[0.25em] text-stone-900 hover:text-[#3d3d3b] transition-colors"
      aria-label="Toggle language"
    >
      <span className={lang === "en" ? "opacity-100" : "opacity-40"}>EN</span>
      <span className="opacity-30">/</span>
      <span className={lang === "ru" ? "opacity-100" : "opacity-40"}>RU</span>
    </button>
  );
};
